import React from 'react'
import AppNavbar from '../Components/AppNavbar'
import Caroussel from '../Components/Caroussel'
import Content from '../Components/Content'

function School() {
  return (
    <div className='School'>
        <AppNavbar/>
        <Caroussel /><br/>
        <Content />
    </div>
  )
}

export default School